export function dashboardTimeEntryModificationsItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-time-entry-modifications.html";
    const html = /*html*/`<apex-dashboard-time-entry-modifications-container>
        </apex-dashboard-time-entry-modifications-container>`;
    $templateCache.put(path, html);
}

export function dashboardTimeEntryModificationsListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-time-entry-modifications.html";
    const html = /*html*/`
        <div ng-if="dashboard.count > 0">
            <p>Some employees have not acknowledged modifications that you have made to their time entries.</p>
        </div>
        <div ng-if="!dashboard.count === 0">
            <p>
                <span class="glyphicon fas fa-check-circle"></span>
                You have not modified any time entries that are still awaiting the employee's acknowledgment.
            </p>
        </div>
    `;
    $templateCache.put(path, html);
}
